<!-- Header -->
<div class="content-heading">
    {{ 'MENU.ITEM.SUPPORT' | translate }}
</div>

<!-- Contact tiles -->
<div class="container-xl">
    <div class="row">
        <div class="col-sm-6 col-md-4 col-lg-3">
            <div class="card b">
                <div class="card-body text-center">
                    <a class="link-unstyled text-info">
                        <em class="fa fa-3x fa-life-ring mb-3"></em>
                        <br/>
                        <span class="h4">{{ 'ROUTES.SUPPORT.MENU.ITEM.TECHNICAL.TITLE' | translate }}</span>
                        <br/>
                        <div class="text-sm text-muted">
                            {{ 'ROUTES.SUPPORT.MENU.ITEM.TECHNICAL.SUBTITLE.1' | translate }} ({{ 'ROUTES.SUPPORT.MENU.ITEM.TECHNICAL.SUBTITLE.2' | translate }} {{ 'SUPPORT.TECHNICAL.TIME' | translate }})
                        </div>
                        <br/>
                        <div class="text-muted">
                            <a href="mailto:support@invitedesk.com">{{ 'SUPPORT.TECHNICAL.MAIL' | translate }}</a>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>